<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6 col-xs-12" style="background-color: #f7f7f7">
        <div :class="{ 'plr-7': !mobile }">
          <h1
            class="mt-2 mb-4 center color-primary"
            style="font-family: Comfortaa-Bold"
          >
            Jovool
          </h1>
        </div>
        <!-- <transation enter-active-class="bounceLeft-enter" leave-active-class="bounceRight-leave"> -->
        <transition name="fadeLeft" mode="out-in" appear>
          <div v-if="show">
            <div :class="{ 'plr-7': !mobile }">
              <p class="f17">
                INFORME-NOS SEUS DADOS E NOSSO TIME ENTRARÁ EM CONTATO O MAIS
                RÁPIDO POSSÍVEL!
              </p>
              <inputform
                type="text"
                placeholder="NOME"
                v-model="lead.name"
                :field="$v.lead.name"
              />

              <inputform
                type="email"
                placeholder="EMAIL"
                v-model="lead.email"
                :field="$v.lead.email"
              />

              <inputform
                type="text"
                placeholder="TELEFONE"
                v-model="lead.mobile_phone"
                :field="$v.lead.mobile_phone"
                v-mask="'(##)#####-####'"
              />
              <inputform
                type="text"
                placeholder="EMPRESA"
                v-model="lead.company"
                :field="$v.lead.company"
              />

              <textareaform
                placeholder="DESCRIÇÃO"
                rows="5"
                :field="$v.lead.message"
                v-model="lead.message"
              ></textareaform>

              <button @click="save" class="btn btn-degrade full normal-degrade">
                {{ !load ? "ENVIAR" : "" }}
                <div
                  v-show="load"
                  class="spinner-border text-light"
                  role="status"
                >
                  <span class="sr-only"></span>
                </div>
              </button>
            </div>
          </div>
        </transition>
        <!-- </transation> -->
      </div>
      <transition name="fade">
        <div
          v-if="show && !mobile"
          class="col-lg-6 center col-xs-12 p-7 loginPanel"
          style="min-height: 100vh"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import { isMobile } from "mobile-device-detect";
export default {
  data: () => ({
    show: false,
    load: false,
    lead: {
      name: "",
      email: "",
      message: "",
      company: "",
      subject: "Nova empresa interessada na jovool",
      mobile_phone: "",
    },
    mobile: isMobile,
  }),

  mounted() {
    let self = this;
    setTimeout(() => {
      this.show = true;
      this.stepOne = true;
    }, 500);
  },
  methods: {
    save() {
      this.load = true;
      this.$v.lead.$touch();
      if (this.$v.lead.$invalid) {
        this.$toast.error("Preencha o formulário corretamente");
        this.load = false;
        return;
      }
      axios
        .post("/lead/create", {
          lead: this.lead,
        })
        .then((response) => {
          this.$toast.success(
            "Email enviado com sucesso, em breve entraremos em contato"
          );
          this.load = false;
        });
    },
  },
  validations: {
    lead: {
      name: { required, minLength: minLength(4) },
      email: { required, email },
      message: { required },
      mobile_phone: { required },
      company: { required, minLength: minLength(3) },
    },
  },
};
</script>

